<section class="section proyects" id='proyects'>
    <div class="container">
        <div class="section-box">
            <div data-aos="fade-up" data-aos-duration="1000">
                <h3 class="section-title">
                  {{"FeatureProjects.Title" | translate}}
                </h3>
            </div>

          <div *ngFor='let project of "FeatureProjects.Projects" | translate; let i = index'
               class="d-flex proyect-container" data-aos="fade-up" data-aos-duration="1000"
               [class.justify-content-end]='i%2!==0' [class.justify-content-start]='i%2==0'>
            <div [class.proyect-info-right]='i%2!==0' [class.proyect-info-left]='i%2==0' class="h-100">
              <div class="proyect-box">
                <h4 [class.text-right]='i%2!==0' [class.text-left]='i%2==0' class="feature-proyect">{{"FeatureProjects.Label" | translate}}</h4>
                <h5 [class.text-right]='i%2!==0' [class.text-left]='i%2==0' class="proyect-name">{{project.Title}}</h5>

                <div class="proyect-description-box">
                  <p class="mb-0" [innerHTML]="project.Description">
                  </p>
                </div>
                <ul [class.justify-content-end]='i%2!==0' [class.justify-content-start]='i%2==0' class="proyect-skills">
                  <li *ngFor='let technology of project.Technologies' class="ml-3">
                    <span class="underline technology">{{technology}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
    </div>
</section>
